/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SubjectTypeEnum {
    subject_type_unspecific = 0,
    subject_type_math = 1,
    subject_type_german = 2,
    subject_type_chemistry = 4,
    subject_type_physics = 5,
    subject_type_biology = 6,
    subject_type_economy = 7,
    subject_type_history = 8,
    subject_type_politics = 9,
    subject_type_geographie = 10,
    subject_type_religion = 11,
    subject_type_ethics = 12,
    subject_type_philosophie = 13,
    subject_type_music = 14,
    subject_type_english = 15,
    subject_type_foreign_languages = 16,
    subject_type_personal_education = 17,
    subject_type_technology = 18,
    subject_type_natural_sciences = 19,
    subject_type_art = 20,
    subject_type_sport = 21,
    subject_type_computer_science = 22,
    subject_type_media = 23,
    subject_type_other = 24,
    subject_type_esl = 25,
}
